
import React from 'react';
import { Award, Calendar, ExternalLink } from 'lucide-react';
import { CERTIFICATIONS } from '../constants';
import { motion } from 'framer-motion';

const Certifications: React.FC<{ darkMode: boolean }> = ({ darkMode }) => {
  return (
    <div className="py-10">
      <div className="flex items-center gap-3 mb-12">
        <Award className="text-blue-600" />
        <h3 className="text-3xl font-bold">Certifications</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {CERTIFICATIONS.map((cert, idx) => (
    <motion.div 
            key={idx} 
            whileHover={{ y: -5 }}
            className="flex flex-col sm:flex-row items-start sm:items-center gap-5 p-6 bg-slate-50 dark:bg-slate-900/40 rounded-3xl border border-slate-200 dark:border-slate-800 hover:bg-white dark:hover:bg-slate-900 transition-all duration-300 shadow-sm hover:shadow-xl group"
          >            <div className="p-3 bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-2xl">
              <Award size={32} className={cert.icon ? "hidden" : ""} />
              <img src={cert.icon} alt={cert.title} className={cert.icon ? "block w-8 h-8" : "hidden"} />
            </div>
           <div className="flex-1">
              <h4 className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-slate-900'} mb-1`}>{cert.title}</h4>
              <p className="text-slate-500 mb-3">{cert.issuer}</p>
              <div className="flex items-center gap-2 text-sm text-slate-400">
                <Calendar size={14} />
                <span>Issued: {cert.date}</span>
              </div>
            </div>
           <motion.a
              href={cert.link}
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="mt-4 sm:mt-0 px-4 py-2 cursor-pointer bg-white dark:bg-slate-800 text-blue-600 dark:text-blue-400 border border-blue-200 dark:border-blue-900/50 rounded-xl text-sm font-bold flex items-center gap-2 hover:bg-blue-50 dark:hover:bg-blue-900/20 transition-colors shadow-sm"
            >
              View <ExternalLink size={14} />
            </motion.a>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Certifications;
